import { hasClass, addClass, removeClass, debounce } from './_utilities';

// Visibility class for table rows
const visibleClass = 'channel-lineup__row--visible';

// Class of row that signifies no channels available (hide)
const noChannelsClass = 'channel-lineup__row--no-channels';

// Selected class for highlighting selected filter
const selectedClass = 'channel-lineup__filter--selected';

// Highlight class for alternating row background colors
const highlightClass = 'channel-lineup__row--highlight';

// Table class name
const tableClass = 'table--channel-lineup';

// Set default/current filter state
let selectedFilter = 'all';

// Highlighting alternating rows in the table
const highlightRows = () => {
    // Create nodeList of all visible channel rows
    const visibleRows = document.querySelectorAll(`.${visibleClass}`);

    // Set initial row count
    let count = 0;

    // Loop/map through visible channels nodeList
    Array.prototype.map.call(visibleRows, (el) => {
        // Increment counter for modulus check
        count = count + 1;

        // If modulus is even and doesn't have class already, add it
        if (count % 2 === 0) {
            // Add highlight class
            addClass(el, highlightClass);
            // If row is odd and also has the class, remove it
        } else if (hasClass(el, highlightClass)) {
            // Remove highlight class from row
            removeClass(el, highlightClass);
        }
    });
};

// Filter display of channel rows from table
const filterBy = (filter) => {
    // Create nodeList of all channel rows
    const channelRows = document.querySelectorAll('[data-channel-type]');

    let channelExistsForFilter = false;

    // If filter is all add visible class to any element that doesn't have it already
    if (filter === 'all') {
        // Loop through channel rows nodeList
        Array.prototype.map.call(channelRows, (el) => {
            // Check for existing class on element
            if (
                el.dataset.channelType !== 'popular' &&
                !hasClass(el, visibleClass)
            ) {
                // Add visibility class
                addClass(el, visibleClass);
                channelExistsForFilter = true;
            } else if (
                el.dataset.channelType === 'popular' &&
                hasClass(el, visibleClass)
            ) {
                // Add visibility class
                removeClass(el, visibleClass);
            }
        });
        // All other filter options
    } else {
        // Loop/map through channel rows nodeList
        Array.prototype.map.call(channelRows, (el) => {
            // If element data attribute matches current filter add the class to make it visible
            if (el.dataset.channelType.indexOf(filter) >= 0) {
                addClass(el, visibleClass);
                channelExistsForFilter = true;
                // Otherwise remove the class
            } else {
                removeClass(el, visibleClass);
            }
        });
    }

    // Check for table element/class before trying to highlight rows
    const channelTable = document.querySelector(`table.${tableClass}`);

    // If we have a table element, proceed with highlighting logic
    if (channelTable !== null) {
        // Toggle our row classes for even/odd highlighting
        highlightRows(visibleClass);
    } else {
        const noChannelsRow = document.querySelector(`.${noChannelsClass}`);
        if (!channelExistsForFilter) {
            removeClass(noChannelsRow, 'hide');
        } else {
            addClass(noChannelsRow, 'hide');
        }
    }
};

// Apply filter visbility classes
const selectFilter = (target) => {
    // Set clicked filter value
    const filter = target.dataset.filter;

    // Check for existing class on selected element
    if (filter !== selectedFilter && !hasClass(target, selectedClass)) {
        // Find currently selected filter
        const currentSelected = document.querySelector(`.${selectedClass}`);
        // Remove selected class from previous selection
        removeClass(currentSelected, selectedClass);

        // Add selected class to current selection
        addClass(target, selectedClass);

        // Update selected filter
        selectedFilter = filter;

        // Filter list based on attribute value
        filterBy(filter);
    }
};

// Use debounce utility method to throttle clicks on filter options
const filterDebounce = debounce(
    (e) => {
        // Execute filter method on target
        selectFilter(e.target);
    },
    500,
    true
);

// Create event listeners for each filter list item
const addFilterListeners = () => {
    // Create nodeList of all list items with data-filter attributes
    const filters = document.querySelectorAll('[data-filter]');

    // Loop/map through filters element nodeList
    Array.prototype.map.call(filters, (el) => {
        // Add click event listener
        el.addEventListener('click', filterDebounce);
    });
};

// Module startup
const init = () => {
    // Check for element on page
    const channelLineupCheck = document.querySelector('[data-channel-lineup]');

    // If we have the channel lineup element, run through initialization
    if (channelLineupCheck !== null) {
        // Initial filtering of lineups
        filterBy(selectedFilter);

        // Bind filter event listeners
        addFilterListeners();
    }
};

export { init };
